<div class="inicio">

  <div class="columnas_layout_3">

    <div class="example-button-row">
      <button mat-mini-fab color="accent" (click)="btnAtras($event)"
        matTooltip="Retornas a ver todas los mantenimeintos"><mat-icon style="transform: rotate(180deg);">forward
          icon</mat-icon></button>
    </div>

    <div class="columnas_layout" *ngIf="!mostrarRazonCancelacion()">
      <mat-label class="titulo">
        DETALLE DE MANTENIMIENTO
        <button mat-mini-fab color="primary" *ngIf="!mostrarRazonCancelacion()" matTooltip="Click para más información"
          (click)="clickMasInformacionR($event)"> <mat-icon>info</mat-icon> </button>
      </mat-label>
    </div>

    <div class="columnas_layout" *ngIf="mostrarRazonCancelacion()">
      <mat-label class="titulo">
        MANTENIMIENTO CANCELADO
        <button mat-mini-fab color="primary" *ngIf="mostrarRazonCancelacion()" matTooltip="Click para más información"
          (click)="clickMasInformacionC($event)"> <mat-icon>info</mat-icon> </button>
      </mat-label>
    </div>

  </div>

  <br><br><br>

  <div class="columnas_layout_4">

    <div class="columnas_layout">
      <mat-label class="negrita">SUCURSAL:</mat-label>
      <mat-label class="texto">{{registro_mantenimiento.nombre_sucursal}}</mat-label>
    </div>

    <div class="columnas_layout">
      <mat-label class="negrita">MANTENIMIENTO:</mat-label>
      <mat-label class="texto">{{registro_mantenimiento.descripcion}}</mat-label>
    </div>

    <div class="columnas_layout">
      <mat-label class="negrita" *ngIf="!habilitarlabels()">FECHA DE REGISTRO:</mat-label>
      <mat-label class="negrita" *ngIf="habilitarlabels()">FECHA PROGRAMADA:</mat-label>
      <mat-label class="texto">{{fecha_programada}}</mat-label>
    </div>

    <div class="columnas_layout">
      <mat-label class="negrita" *ngIf="!mostrarRazonCancelacion()">FECHA DE REALIZACIÓN:</mat-label>
      <mat-label class="negrita" *ngIf="mostrarRazonCancelacion()">FECHA DE CANCELACIÓN:</mat-label>
      <mat-label class="texto">{{fecha_modificacion}}</mat-label>
    </div>

    <div class="columnas_layout">
      <mat-label class="negrita" *ngIf="!habilitarlabels()"> REGISTRADO POR:</mat-label>
      <mat-label class="negrita" *ngIf="habilitarlabels()"> AGENDADO POR:</mat-label>
      <mat-label class="texto">{{registro_mantenimiento.nombre_empleado_registra}}</mat-label>
    </div>

    <div class="columnas_layout">
      <mat-label class="negrita" *ngIf="!mostrarRazonCancelacion()"> REALIZADO POR:</mat-label>
      <mat-label class="negrita" *ngIf="mostrarRazonCancelacion()">CANCELADO POR:</mat-label>
      <mat-label class="texto">{{registro_mantenimiento.nombre_empleado_realiza}} </mat-label>
    </div>

    <div class="columnas_layout">
      <mat-label class="negrita" *ngIf="!mostrarRazonCancelacion()"> COMENTARIOS:</mat-label>
      <mat-label class="negrita" *ngIf="mostrarRazonCancelacion()">CAUSA DE CANCELACIÓN:</mat-label>
      <mat-label class="texto">{{registro_mantenimiento.observ_generales}}</mat-label>
    </div>

    <div class="columnas_layout" *ngIf="!mostrarRazonCancelacion()">
      <mat-label class="negrita">MINUTA DE MANTENIMIEIEINTO:</mat-label>
      <div class="example-button-row">
        <button mat-raised-button color="primary" matTooltip="Descarga la minuta de mantenimeinto"
          [disabled]="!habilitarBotonDescargarMinuta()"
          (click)="descargarMinutaMantenimiento()">Descargar<mat-icon>download</mat-icon> </button>
      </div>
    </div>



  </div>

  <br><br><br>

  <div class="columnas_layout" *ngIf="!mostrarRazonCancelacion()">
    <mat-form-field class="example-full-width" appearance="fill">
      <mat-label class="label"> COLABORADOR QUE AVALA EL MANTENIMIENTO</mat-label>
      <input type="text" matInput [formControl]="colaborador" [matAutocomplete]="auto"
        oninput="this.value = this.value.toUpperCase()">
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
        (optionSelected)="clickCargarDatosColaborador($event.option.value)">
        <mat-option *ngFor="let option of listaFiltradaColaboradores | async" [value]="option"> {{option.nomb_compl}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="table">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <ng-container matColumnDef="NOMBRE DEL EQUIPO">
        <th mat-header-cell *matHeaderCellDef> NOMBRE DEL EQUIPO </th>
        <td mat-cell *matCellDef="let element"> {{element.nombre_equipo}} </td>
      </ng-container>


      <ng-container matColumnDef="TIPO DE EQUIPO">
        <th mat-header-cell *matHeaderCellDef> TIPO DE EQUIPO </th>
        <td mat-cell *matCellDef="let element"> {{element.tipo_activo}} </td>
      </ng-container>

      <ng-container matColumnDef="COMENTARIOS DE USUARIO">
        <th mat-header-cell *matHeaderCellDef> COMENTARIOS DE USUARIO </th>
        <td mat-cell *matCellDef="let element"> {{element.comentarios_usuario}} </td>
      </ng-container>

      <ng-container matColumnDef="OBSERVACIONES">
        <th mat-header-cell *matHeaderCellDef> OBSERVACIONES </th>
        <td mat-cell *matCellDef="let element"> {{element.observ_equipo}} </td>
      </ng-container>

      <ng-container matColumnDef="TIPO DE MANTENIMIENTO">
        <th mat-header-cell *matHeaderCellDef> TIPO DE MANTENIMIENTO </th>
        <td mat-cell *matCellDef="let element"> {{element.tipo_mantenimiento_rea}} </td>
      </ng-container>

      <ng-container matColumnDef="ACTIVIDADES REALIZADAS">
        <th mat-header-cell *matHeaderCellDef> ACTIVIDADES REALIZADAS </th>
        <td mat-cell *matCellDef="let element"> {{element.actividades_realizadas}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listaEncabezados"></tr>
      <tr mat-row *matRowDef="let row; columns: listaEncabezados;"></tr>
    </table>
    <mat-paginator class="paginator" #paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]"
      showFirstLastButtons></mat-paginator>
  </div>

</div>